import { useCallback, useRef, useState } from "react";
import useDocumentEvent from "../events/useDocumentEvent";

export default function useDropdown(initialState = false, onAfterClose = null) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(initialState);

  const handleClickOutside = useCallback(
    (event) => {
      if (ref.current && ref.current.contains(event.target)) {
        return;
      }
      setIsOpen(false);
      onAfterClose && onAfterClose();
    },
    [ref, onAfterClose]
  );

  const handleHideDropdown = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
        onAfterClose && onAfterClose();
      }
    },
    [onAfterClose]
  );

  useDocumentEvent([
    { type: "click", callback: handleClickOutside },
    { type: "keydown", callback: handleHideDropdown },
  ]);

  return [ref, isOpen, setIsOpen];
}
